class AuthorEditView {
  constructor($el) {
    if (!$el.length) return
    this.$root = $el
    this.initUploader()
    this.initDynamicFields()
  }

  initUploader() {
    this.$root.find('.authors__photo-uploader').each(function () {
      const $root = $(this)
      const $fileInput = $root.find('.authors__photo-uploader-hidden-input')

      $fileInput.off('change').on('change', event => {
        const imagePath = URL.createObjectURL(event.currentTarget.files[0])
        $root.find('.authors__photo-uploader-image').css('background-image', `url(${imagePath})`)
      })
    })
  }

  initDynamicFields() {
    this.initExtraMaterials()
    this.initEducation()
    this.initCertifications()
  }

  initExtraMaterials() {
    const $extraMaterialsContainer = $('#extra-materials')

    $('#add-material')
      .off('click')
      .on('click', e => {
        e.preventDefault()
        const newField = `
        <div class="extra-materials-group">
          <div class="extra-materials-input">
            <input type="text" name="author[extra_materials][][url]"
            class="text-field" placeholder="Link URL">
          </div>
          <div class="extra-materials-input">
            <input type="text" name="author[extra_materials][][text]"
            class="text-field" placeholder="Link Text">
          </div>
          <div class="extra-materials-remove">
            <a href="#" class="remove-link-row">Remove</a>
          </div>
        </div>
      `
        $('#extra-materials').append(newField)
      })

    $extraMaterialsContainer
      .off('click', '.remove-link-row')
      .on('click', '.remove-link-row', function (e) {
        e.preventDefault()
        $(this).closest('.extra-materials-group').remove()
      })
  }

  initEducation() {
    const $educationContainer = $('#education')

    $('#add-education')
      .off('click')
      .on('click', e => {
        e.preventDefault()
        const newField = `
        <div class="form__input">
          <input type="text" name="author[education][]" class="text-field">
          <a href="#" class="remove-education-row">Remove</a>
        </div>
      `
        $educationContainer.append(newField)
      })

    $educationContainer
      .off('click', '.remove-education-row')
      .on('click', '.remove-education-row', function (e) {
        e.preventDefault()
        $(this).closest('.form__input').remove()
      })
  }

  initCertifications() {
    const $certificationsContainer = $('#certifications')

    $('#add-certification')
      .off('click')
      .on('click', e => {
        e.preventDefault()
        const newField = `
        <div class="form__input">
          <input type="text" name="author[certifications][]" class="text-field">
          <a href="#" class="remove-certification-row">Remove</a>
        </div>
      `
        $certificationsContainer.append(newField)
      })

    $certificationsContainer
      .off('click', '.remove-certification-row')
      .on('click', '.remove-certification-row', function (e) {
        e.preventDefault()
        $(this).closest('.form__input').remove()
      })
  }
}

document.addEventListener('DOMContentLoaded', function () {
  new AuthorEditView($('.author-edit-view'))
})
